import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { LoadingService } from '../services/loading.service';

/**
 * Intercepts every HTTP request and shows/hides the global spinner.
 * Auth endpoints (/auth/*) are explicitly excluded so login/logout
 * flows don't trigger the overlay loader.
 */

/** Exact path segments that belong to the auth *flow* (not data management) */
const AUTH_FLOW_PATHS = [
  '/auth/login',
  '/auth/logout',
  '/auth/status',
  '/auth/methods',
  '/auth/microsoft',
  '/auth/2fa',
];

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loading = inject(LoadingService);

  // Skip auth routes — they manage their own loading state
  const isAuthRequest = req.url.includes('/auth/');
  if (isAuthRequest) {
    return next(req);
  }

  loading.show();

  return next(req).pipe(finalize(() => loading.hide()));
};

